













































































































export default{
  data: () => ({ 
      languages: [{name:'español', code:'es'},{name:'english', code:'en'}],
      isActive: false
    } 
  ),
  methods: {
    changeLang ( lang) {
      this.$i18n.locale = lang
    },
    toggleActive () {
      this.isActive = !this.isActive
    }
  },
  mounted() {
    setTimeout(() => { this.isFixed = true;}, 2500);
    setTimeout(() => { this.isFixed = false;}, 5000);
  }
}
